import React, { useEffect, useState } from 'react'
import { Col, Row } from 'antd'
import Avatar from 'avataaars';
import Customavatar from './customavatar/customavatar';
import { avataaarsURL, avatarConfigs } from '../../../../../utils/data';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../../store/store';
import {
	LoadingOutlined,
} from '@ant-design/icons';
import { openNotificationWithIcon } from '../../../../../utils/helper';
import { updateUserAvatar } from '../../../../../api/user/user';
import { updateUser } from '../../../../../store/userSlice/userSlice';

const avatarTypes = ['Top', 'Accessories', 'Hat Color', 'Hair Color', 'Facial Hair', 'Facial Hair Color', 'Cloth', 'Cloth Color', 'Graphic', 'Eyes', 'Eyebrow', 'Mouth', 'Skin']

const avatarTypesNaming = ['topType', 'accessoriesType', 'hatColor', 'hairColor', 'facialHairType', 'facialHairColor', 'clotheType', 'clotheColor', 'graphicType', 'eyeType', 'eyebrowType', 'mouthType', 'skinColor']

const Teacheravatar = () => {
	const dispatch = useDispatch()

	const [updating, setUpdating] = useState(false)
	const [currentIndex, setCurrentIndex] = useState(0)
	const [mainAvatarValues, setMainAvatarValues] = useState({
		topType: 'LongHairStraight',
		accessoriesType: 'LongHairStraight',
		hairColor: 'BrownDark',
		facialHairType: 'Blank',
		clotheType: 'BlazerShirt',
		eyeType: 'Default',
		eyebrowType: 'Default',
		mouthType: 'Default',
		skinColor: 'Light',
	})


	const state = useSelector((state: RootState) => ({
		user: state.user.user,
	}))

	const { user } = state


	const getVariables = (index: number) => {
		let attributeName = avatarTypesNaming[index]
		let content = avatarConfigs[attributeName]
		return content
	}

	const updateAttribute = (value: string) => {
		setMainAvatarValues((prevState: any) => ({
			...prevState,
			[avatarTypesNaming[currentIndex]]: value
		}))
	}

	const updateAvatar = async () => {
		try {
			setUpdating(true)
			let urlLink = ''

			let totalLength = Object.keys(mainAvatarValues).length
			let lastIndex = totalLength - 1

			Object.entries(mainAvatarValues).forEach(([key, value]: any, index) => {
				urlLink += `${key}=${value}${index === lastIndex ? '' : '&'}`
			})

			const res = await updateUserAvatar({
				userAvatarURL: `${avataaarsURL}${urlLink}`
			})

			dispatch(updateUser({
				user: {
					...user,
					userAvatarURL: `${avataaarsURL}${urlLink}`
				}
			}))

			const { message } = res.data

			openNotificationWithIcon('success', 'Update Avatar', message)

			setUpdating(false)

		} catch (error: any) {
			setUpdating(false)
			if (error?.response) {
				openNotificationWithIcon('error', 'Update AI Tutor', `${error?.response?.data?.message || 'Something went wrong'}`)
			} else {
				openNotificationWithIcon('error', 'Update AI Tutor', 'Something went wrong')
			}
		}
	}

	useEffect(() => {
		if (user?.userAvatarURL !== undefined && user?.userAvatarURL !== '') {
			const avatarAttributes = user?.userAvatarURL.split(avataaarsURL)[1]

			const keyValuePairs = avatarAttributes.split('&');
			const result: any = {};

			keyValuePairs.forEach((pair: any) => {
				const [key, value] = pair.split('=');
				result[key] = value;
			});

			setMainAvatarValues((prevState: any) => ({
				...prevState,
				...result
			}))

		}

		// eslint-disable-next-line
	}, [])


	return (
		<div className='h-screen'>
			<Row gutter={16}>
				<Col xs={24} md={24} lg={12}>
					<div className='flex flex-col border rounded-[30px] custom-primary-bg-three p-4 h-full min-h-[40rem]'>
						<div className='flex items-center justify-center m-auto'
						>
							<Avatar
								avatarStyle='Transparent'
								className='w-[12.5rem] h-[12.5rem]'
								{
								...mainAvatarValues
								}
							/>
						</div>

						<div className='flex justify-between'>
							<p className='px-5 py-3 cursor-pointer text-appcolorwhite rounded-[2.5rem] bg-appcolorwhiteten text-base font-medium'>
								Clean Slate
							</p>

							<div className='flex'>
								<p className='px-5 py-3 cursor-pointer text-appcolorwhite rounded-[2.5rem] bg-appcolorwhiteten text-base font-medium mr-[0.6rem]'>
									Cancel
								</p>

								<p className='px-5 py-3 cursor-pointer text-appcolorwhite rounded-[2.5rem] bg-appcolorwhiteten text-base font-medium flex items-center'
									onClick={() => {
										updateAvatar()
									}}
								>

									{
										updating ?
											<LoadingOutlined
												className='mr-[0.5rem]'
											/> : null
									}

									<span>
										Save Changes
									</span>
								</p>
							</div>
						</div>
					</div>
				</Col>
				<Col xs={24} md={24} lg={12}>
					<div>
						<div className='flex flex-wrap justify-between after:content-[""] after:flex-auto'>
							{
								avatarTypes.map((item, index) => (
									<p key={`avatar-type-${item}`}
										onClick={() => {
											setCurrentIndex(index)
										}}
										className={`mb-4 cursor-pointer mr-1 py-[0.5rem] px-4 w-fit text-appcolorblack opacity-[0.6] rounded-[10px] ${avatarTypes[currentIndex] === item ? 'font-bold bg-appcolorpurplefaint' : ''} hover:font-bold hover:bg-appcolorpurplefaint`}
									>{item}</p>
								))
							}
						</div>

						<div className='flex flex-wrap justify-between after:content-[""] after:flex-auto'>
							{
								getVariables(currentIndex).map((item: string, index: number) => (
									<div className='mb-4'
										key={`reward-${index}-avatar`}
									>
										<Customavatar
											currentAttributeName={avatarTypesNaming[currentIndex]}
											currentAttributeValue={item}
											updateAttribute={updateAttribute}
											mainAvatarValues={mainAvatarValues}
										/>
									</div>
								))
							}
						</div>
					</div>
				</Col>
			</Row>
		</div>
	)
}

export default Teacheravatar